<template>
    <BContainer>
        <SecondLevelNavigation class="mt-2" :items="menuItems" :active-index="activeIndex" v-if="content?.menu_items?.length > 0"/>
        <h1 class="mt-2">{{content?.title}}</h1>
        <div v-html="content?.html_content"></div>
    </BContainer>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router'
import SecondLevelNavigation from '@/components/site/SecondLevelNavigation.vue'
import { computed } from 'vue'
import { definePageMeta, useLocalePath } from '#imports'

const localePath = useLocalePath() 
const route = useRoute()
const path = route.fullPath
const content = useState('dynamic-content-' + path)

const menuItems = computed(() => (content.value?.menu_items ?? []).map((item: { title: string; url: string }) => {
    return { 
        label: item.title,
        href: localePath(item.url),
    }
}))

type MenuItem = { label: string; href: string }
const activeIndex = computed(() => {
    return menuItems.value.findIndex((item: MenuItem) => item.href === path)
})

definePageMeta({
  auth: 'guest',
  layout: 'site-layout-content',
  name: 'dynamic-fallback'
})

useHead({
    title: content?.value?.title,
})
</script>